import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GooglePlaceApiService } from '../../../../core/services/google-place-api.service';
import { MessageService } from 'primeng/api';
import { timeout } from 'rxjs';

@Component({
  selector: 'app-search-location-widget',
  templateUrl: './search-location-widget.component.html',
  styleUrls: ['./search-location-widget.component.scss'],
})
export class SearchLocationWidgetComponent implements OnInit {
  @Input() type: string = '';
  @Output() searchLocationDataOnchange: EventEmitter<any> = new EventEmitter();
  @Output() searchLocationActionsOnchange: EventEmitter<any> =
    new EventEmitter();
  searchInput = '';
  placeOptions: any[] = [];
  searchLocationLoading = false;
  fetchPlaceLoading = false;

  constructor(
    private placeApiService: GooglePlaceApiService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
  }

  inputOnChange(): void {
    this.searchLocationLoading = true;
    setTimeout(() => {
      if (this.searchInput) {
        this.getPlacePredictions();
      } else {
        this.searchLocationLoading = false;
        this.placeOptions = [];
      }
    }, 500);
  }

  getPlacePredictions(): void {
    const param = this.searchInput.replace(/\//g, ' ');
    this.placeOptions = [];
    this.placeApiService.getPlacePredictions(param).subscribe(
      (res: any) => {
        if (res.status === 'ZERO_RESULTS') {
          this.searchLocationLoading = false;
          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: `No place suggestions`,
          });
        } else {
          this.searchLocationLoading = false;
          this.placeOptions = res?.predictions;
        }
      },
      (e: any) => {
        this.searchLocationLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${e?.error?.message ? e?.error?.message : 'Error'}`,
        });
      }
    );
  }

  getPlaceById(place: any): void {
    this.handleActionEventEmitter(true);
    this.placeApiService.getPlaceById(place?.place_id).subscribe(
      (res: any) => {
        const address = res;
        const components: any[] = [];
        const addressComponents = res?.addressComponents;
        let streetNumComp: any;
        let subPremiseComp: any;

        const hasSubPremise = res?.addressComponents?.some((component: any) =>
          component.types.includes('subpremise')
        );

        const hasStreetNum = res?.addressComponents?.some((component: any) =>
          component.types.includes('street_number')
        );

        streetNumComp = hasStreetNum
          ? res?.addressComponents?.find(
              (comp: any) => comp.types[0] === 'street_number'
            )
          : null;
        subPremiseComp = hasSubPremise
          ? res?.addressComponents?.find(
              (comp: any) => comp.types[0] === 'subpremise'
            )
          : null;

        if (hasStreetNum && hasSubPremise) {
          components.push({
            types: ['unit'],
            long_name: `${subPremiseComp?.longText}, ${streetNumComp?.longText}`,
          });
        } else if (hasStreetNum && !hasSubPremise) {
          components.push({
            types: ['unit'],
            long_name: `${streetNumComp?.longText}`,
          });
        } else if (hasSubPremise && !hasStreetNum) {
          components.push({
            types: ['unit'],
            long_name: `${subPremiseComp?.longText}`,
          });
        }

        addressComponents?.forEach((comp: any) => {
          components.push({
            types: comp?.types,
            long_name: comp?.longText,
          });
        });
        this.handleDataEventEmitter({
          id: address?.id,
          address_components: components,
        });
        this.placeOptions = [];
        this.searchInput = '';
        this.handleActionEventEmitter(false);
      },
      (e: any) => {
        this.fetchPlaceLoading = false;
        this.handleActionEventEmitter(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `${e?.error?.message ? e?.error?.message : 'Error'}`,
        });
      }
    );
  }

  handleDataEventEmitter(value: any): void {
    switch (this.type) {
      case 'component':
        this.searchLocationDataOnchange.emit({
          name: 'component-address',
          value: value,
        });
        break;
      case 'popup':
        this.searchLocationDataOnchange.emit({
          name: 'popup-address',
          value: value,
        });
        break;
    }
  }

  handleActionEventEmitter(value: boolean): void {
    switch (this.type) {
      case 'component':
        this.placeApiService.placeFetchingInfo.next({
          type: 'component',
          value: value,
        });
        break;
      case 'popup':
        this.placeApiService.placeFetchingInfo.next({
          type: 'popup',
          value: value,
        });
        break;
    }
  }
}
